module.exports = __webpack_public_path__ + "static/media/blood-pressure-sugar.af3320ef.svg";